import {
    paramValue,
    paramFormat,
    paramCulture,
} from '../constants/parameterNames';
import {
    getDoubleParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';

const FORMAT_NUMBER_ERROR = 'Unable to format number.';

const requiredParameters = {
    [paramValue]: {
        description: 'The number value to apply the format to',
    },
    [paramFormat]: {
        description:
            'The standard or custom .NET format for the returned string.',
    },
};

const optionalParameters = {
    [paramCulture]: {
        description: 'The desired culture provider for the returned string',
    },
};

const description = 'Formats a number into the specified format.';

const getSettings = (parameters) => ({
    numberToFormat: getDoubleParamValue(parameters, paramValue, null, false),
    format: getParamValue(parameters, paramFormat),
    culture: getParamValue(parameters, paramCulture),
});

const executeAsync = async ({ api, parameters }) => {
    const settings = getSettings(parameters);

    const data = await api.formatNumber(settings);

    if (!data) {
        throw new Error(FORMAT_NUMBER_ERROR);
    }

    if (!data.Success) {
        throw new Error(data.Error || FORMAT_NUMBER_ERROR);
    }

    return data.Data;
};

const FormatNumber = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default FormatNumber;
